import * as React from 'react'

class ZIndex extends React.Component {
  public static displayName = 'ZIndex'

  public render() {
    return (
      <div className="z-index">
        <section>
          <h1>ZIndex 层级规范</h1>
          <p className="text">
            Xue-react 使用了较为保守的层级设置以确保用户可以轻松覆盖原样式。
          </p>
        </section>
        <table
          className="api-table"
          style={{ maxWidth: '600px', marginTop: '100px' }}
        >
          <thead>
            <tr>
              <th
                className="des"
                style={{
                  textAlign: 'center',
                  backgroundColor: '#e6f7ff',
                  fontWeight: 600
                }}
              >
                Component
              </th>
              <th
                className="type"
                style={{
                  textAlign: 'center',
                  backgroundColor: '#e6f7ff',
                  fontWeight: 600
                }}
              >
                zIndex
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Cascader
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                80
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                DatePicker
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                80
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Menu
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                80
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Popover
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                90
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Affix
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                100
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                LightUp
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                100
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Message
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                100
              </td>
            </tr>
            <tr>
              <td
                className="des"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                Modal
              </td>
              <td
                className="type"
                style={{ textAlign: 'center', fontWeight: 600 }}
              >
                100
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default ZIndex



// WEBPACK FOOTER //
// ./src/components/ZIndex.tsx